Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useStyles = void 0;
var _reactNative = require("react-native-web");
var _styles = require("../../styles");
var useStyles = exports.useStyles = function useStyles() {
  var _STYLES$useStyles = _styles.STYLES.useStyles(),
    spacing = _STYLES$useStyles.spacing,
    container = _STYLES$useStyles.container,
    container_noHeader = _STYLES$useStyles.container_noHeader,
    grid = _STYLES$useStyles.grid,
    bp = _STYLES$useStyles.bp;
  var stepsGrid = {
    width: '100%',
    alignSelf: 'center',
    flexDirection: 'row',
    justifyContent: 'center',
    marginBottom: spacing.xl,
    maxWidth: grid.maxBoxWidth
  };
  var stepsGridItem = {};
  if (bp.is([bp.mobile_xs, bp.mobile_s, bp.mobile_normal, bp.mobile_m, bp.mobile_l])) {
    stepsGrid.flexDirection = 'column';
    stepsGrid.alignItems = 'center';
    stepsGridItem.maxWidth = grid.maxBoxWidth;
  }
  var styles = _reactNative.StyleSheet.create({
    emptyMessage: {
      marginBottom: spacing.xxxl,
      justifyContent: 'center',
      flex: 1
    },
    list: {
      marginBottom: spacing.xxxl,
      width: '100%',
      alignItems: 'center'
    },
    messageContainer: {
      width: '100%',
      alignItems: 'center'
    },
    message: {
      width: '100%',
      alignItems: 'center'
    },
    container: Object.assign({}, container, container_noHeader),
    heading: {
      textAlign: 'center',
      marginBottom: spacing.xxxl
    },
    stepsGrid: stepsGrid,
    stepsGridItem: stepsGridItem,
    button: {
      width: '100%',
      flexDirection: 'row',
      justifyContent: 'center',
      marginBottom: spacing.xxxl
    }
  });
  return {
    styles: styles
  };
};